module.exports = __webpack_public_path__ + "static/img/1.bde47a8b.jpg";